import React, { Fragment, Component } from "react";
import "./AboutButton.css";
import { ShineBorder } from "../../../shadcomponents/ui/shine-border";

type Props = {
  aboutProfile: () => void;
  aboutExperience: () => void;
  aboutBuild: () => void;
  aboutTinker: () => void;
};

class AboutButton extends Component<Props> {
  childAboutProfile = () => {
    this.props.aboutProfile();
  };
  childAboutExperience = () => {
    this.props.aboutExperience();
  };
  childAboutBuild = () => {
    this.props.aboutBuild();
  };
  childAboutTinker = () => {
    this.props.aboutTinker();
  };
  render() {
    return (
      <Fragment>
        <div id="aboutbuttoncircles">
          <div className="about1">
            <span
              className="rounded-full text-gray-200 bg-mostblue font-semibold text-sm flex align-center cursor-pointer active:bg-mostbluehover hover:bg-mostbluehover transition duration-300 ease w-max h-20 about-button-wrapper-1"
              onClick={this.childAboutBuild}
            >
              <ShineBorder
                shineColor={["#F827FA", "#FFFFFF", "#2D338C"]}
                borderWidth={1}
                duration={25}
              />
              <img
                className="rounded-full w-20 h-20 max-w-none z-10"
                alt="React Tailwind Animejs"
                src="./weblogo.png"
              />
              <span className="flex items-center px-3 py-2">Web Build</span>
              <button className="bg-transparent hover focus:outline-none">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  className="w-3 mr-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                  onClick={this.childAboutBuild}
                ></svg>
              </button>
            </span>
          </div>
          <div className="about2">
            <span
              className="rounded-full text-gray-200 bg-mostblue font-semibold text-sm flex align-center cursor-pointer active:bg-mostbluehover hover:bg-mostbluehover transition duration-300 ease w-max about-button-wrapper-2"
              onClick={this.childAboutProfile}
            >
              <ShineBorder
                shineColor={["#F827FA", "#FFFFFF", "#2D338C"]}
                borderWidth={1}
                duration={18}
              />
              <img
                className="max-w-none h-[100px] w-auto mt-[-20px] z-10"
                alt="Aaron Villanueva Profile"
                src="./about-profile-thumbs-min.png"
              />
              <span className="flex items-center px-3 py-2">Profile</span>
              <button
                className="bg-transparent hover focus:outline-none"
                onClick={this.childAboutProfile}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  className="w-3 mr-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                ></svg>
              </button>
            </span>
          </div>
          <div className="about3">
            <span
              className="rounded-full text-gray-200 bg-mostblue font-semibold text-sm flex align-center cursor-pointer active:bg-mostbluehover hover:bg-mostbluehover transition duration-300 ease w-max about-button-wrapper-3"
              onClick={this.childAboutExperience}
            >
              <ShineBorder
                shineColor={["#F827FA", "#FFFFFF", "#2D338C"]}
                borderWidth={1}
                duration={22}
              />
              <img
                className="max-w-none h-[100px] w-auto mt-[-10px] z-10"
                alt="Aaron Villanueva Experience"
                src="./about-experience-thumbs-min.png"
              />
              <span className="flex items-center px-3 py-2">Experience</span>
              <button
                className="bg-transparent hover focus:outline-none"
                onClick={this.childAboutExperience}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  className="w-3 mr-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                ></svg>
              </button>
            </span>
          </div>
          <div className="about4">
            <span
              className="rounded-full text-gray-200 bg-mostblue font-semibold text-sm flex align-center cursor-pointer active:bg-mostbluehover hover:bg-mostbluehover transition duration-300 ease w-max about-button-wrapper-4"
              onClick={this.childAboutTinker}
            >
              <ShineBorder
                shineColor={["#F827FA", "#FFFFFF", "#2D338C"]}
                borderWidth={1}
                duration={20}
              />
              <img
                className="max-w-none h-[100px] w-auto mt-[-10px] z-[10]"
                alt="Aaron Villanueva Tinker"
                src="./about-tinker-thumbs-min.png"
              />
              <span className="flex items-center px-3 py-2">Tinker</span>
              <button
                className="bg-transparent hover focus:outline-none"
                onClick={this.childAboutTinker}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  className="w-3 mr-4"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 352 512"
                ></svg>
              </button>
            </span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AboutButton;
